'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import { useSchedulerStoreContext } from "../use-scheduler-store-context/index.mjs";
export function useEventCalendarStoreContext() {
  const context = useSchedulerStoreContext();
  if (context.instanceName !== 'EventCalendarStore' && context.instanceName !== 'EventCalendarPremiumStore') {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: useEventCalendarStoreContext must be used within an <EventCalendar /> component' : _formatErrorMessage(212));
  }
  return context;
}